<template>
    <div>
        <scaffold-form-plus :isAdd="formInfo.isAdd" :relationDialogVisible.sync="formInfo.dialogVisible" showTitle="脚手架定义表"
                  :showData="formInfo.editData"
                  :rules="rules" @submitAdd="submitAdd" @submitEdit="submitEdit" ref="scaffoldForm" defaultEmpty>
            <template v-slot:default="{ruleForm}" class="info">
                        <!-- 脚手架名称 -->
                        <el-form-item :label="columnInfo.name.label" prop="name">
                                <el-input v-model="ruleForm.name" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                        <!-- 脚手架编码 -->
                        <el-form-item :label="columnInfo.code.label" prop="code">
                                <el-input v-model="ruleForm.code" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                        <!-- 版本号 -->
                        <el-form-item :label="columnInfo.version.label" prop="version">
                                <el-input v-model="ruleForm.version" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                        <!-- 脚手架描述 -->
                        <el-form-item :label="columnInfo.description.label" prop="description">
                                <el-input v-model="ruleForm.description" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                        <!-- 脚手架压缩包存储路径 -->
                        <el-form-item :label="columnInfo.scaffoldFilePath.label" prop="scaffoldFilePath">
                                <file-link-upload-select v-model="ruleForm.scaffoldFilePath" object-key-prefix="scaffold" placeholder="请上传脚手架压缩包"></file-link-upload-select>
                        </el-form-item>
                        <!-- 关联模板包 -->
                        <el-form-item :label="columnInfo.templatePackageId.label" prop="templatePackageId">
                                <el-select v-model="ruleForm.templatePackageId" placeholder="请选择" clearable filterable>
                                    <el-option v-for="item in options.templatePackageIdOptions" :key="item.id" :label="item.packageName" :value="item.id"></el-option>
                                </el-select>
                        </el-form-item>
                        <!-- 配置清单JSON -->
                        <el-form-item :label="columnInfo.configSchema.label" prop="configSchema" style="width:100%;">
                                <el-input v-model="ruleForm.configSchema" type="textarea" :rows="6"
                                  placeholder='[{"group":"数据库配置","fields":[{"key":"dbHost","label":"数据库地址","type":"input","required":true,"default":"localhost"}]}]'
                                  clearable></el-input>
                        </el-form-item>
                        <!-- 环境清单JSON -->
                        <el-form-item :label="columnInfo.envRequirements.label" prop="envRequirements" style="width:100%;">
                                <el-input v-model="ruleForm.envRequirements" type="textarea" :rows="4"
                                  placeholder='[{"name":"JDK","version":"17","type":"runtime"},{"name":"Maven","version":"3.8+","type":"build"}]'
                                  clearable></el-input>
                        </el-form-item>
                        <!-- 状态 -->
                        <el-form-item :label="columnInfo.state.label" prop="state">
                                <enum-dict-select v-model="ruleForm.state" module-name="data" dict-code="state"></enum-dict-select>
                        </el-form-item>
            </template>
        </scaffold-form-plus>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from "vuex";
    import FileLinkUploadSelect from "@/components/select/FileLinkUploadSelect";

    export default {
        components: {FileLinkUploadSelect},
        name: 'scaffoldForm',
        computed: {
            ...mapState({
                rules: state => state.data.scaffold.rules,
                tableData: state => state.data.scaffold.tableData,
                formInfo: state => state.data.scaffold.formInfo,
                options: state => state.data.scaffold.options,
                columnInfo: state => state.data.scaffold.columnInfo,
            })
        },
        methods: {
            ...mapMutations({
                setDialogVisible: 'data/scaffold/setDialogVisible',
            }),
            ...mapActions({
                submitAdd: 'data/scaffold/submitAdd',
                submitEdit: 'data/scaffold/submitEdit',
            })
        }
    }
</script>

<style lang="less" scoped>
    .info {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
            width: 50%;
        }
    }
</style>
